'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _canvasStuff = require('./../../../vehicle/vehicleAppraisal/bodywork/canvasStuff');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SimpleDpaController = function () {
  function SimpleDpaController($state, $stateParams, loadingService, contactService, authService) {
    "ngInject";

    (0, _classCallCheck3.default)(this, SimpleDpaController);
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.loadingService = loadingService;
    this.contactService = contactService;
    this.authService = authService;

    if (!$stateParams.contactId || !$stateParams.enquiryId) {
      $state.go('welcomeCentre');
    }

    this.dpa = $stateParams.dpa;

    this.errUpdateDpa = '';

    //this.preventTabletScroll();
    window.setTimeout(this.editImage, 10);
  }

  (0, _createClass3.default)(SimpleDpaController, [{
    key: 'goBack',
    value: function goBack() {
      this.$state.go('enquiryEdit', { enquiryId: this.$stateParams.enquiryId });
    }
  }, {
    key: 'editImage',
    value: function editImage() {
      var $container = $('.signature-container');
      var width = $container.width();
      var height = $container.height();

      var $divCanvas = $('<div idx="imageHolder" style="width:' + width + 'px;height:' + height + 'px;background: url(\'\'); background-repeat: no-repeat; background-size: 100% 100%;"><canvas width="' + width + 'px" height="' + height + 'px" id="sig-canvas"></canvas><canvas width="' + width + 'px" height="' + height + 'px" style="display:none;" id="hidden-canvas"></canvas></div>');
      $('.signature-container').empty().append($divCanvas);
      (0, _canvasStuff.doMagic)(null, true);
    }
  }, {
    key: 'clearSignature',
    value: function clearSignature() {
      (0, _canvasStuff.clearCanvas)(true);
    }
  }, {
    key: 'confirmVerbalConsent',
    value: function confirmVerbalConsent() {
      if (this.dpa.verbalConsent) {
        this.dpa.verbalConsent = window.confirm('By clicking this checkbox, you will have to sign the DPA on behalf of the customer. Are you sure you want to proceed ?');
      }
    }
  }, {
    key: 'checkOptions',
    value: function checkOptions(val) {
      this.dpa.viaEmail = val;
      this.dpa.viaText = val;
      this.dpa.viaPost = val;
      this.dpa.viaPhone = val;
    }
  }, {
    key: 'updateDpa',
    value: function updateDpa() {
      var ctrl = this;

      if (!ctrl.validateDpa()) {
        return;
      }

      ctrl.loadingService.showLoading('dpa', 'Updating DPA ...');

      ctrl.dpa.signData = (0, _canvasStuff.getCanvasData)();
      ctrl.contactService.updateDpa(ctrl.authService.authData.currentLocation.key, ctrl.dpa).then(function (response) {
        ctrl.loadingService.hideLoading('dpa');
        ctrl.goBack();
      });
    }
  }, {
    key: 'validateDpa',
    value: function validateDpa() {
      this.errUpdateDpa = '';

      if ((0, _canvasStuff.isCanvasEmpty)()) {
        this.errUpdateDpa = 'Please sign the form before submitting';
        return false;
      }

      return true;
    }
  }]);
  return SimpleDpaController;
}();

exports.default = SimpleDpaController;


// WEBPACK FOOTER //
// ./client/app/components/enquiry/enquiryEdit/simpleDpa/simpleDpa.controller.js